import React, { useEffect } from 'react';
import AdminPanelHeader from '../components/layout/AdminPanelHeader';
import AdminProfileData from '../components/layout/AdminProfileData';
import { useAdminPanel } from '../hooks/useAdminPanel';
import { useAdminAuth } from '../context/AdminAuthContext'; // Add this
import { Container, Typography, Box, CircularProgress } from '@mui/material';

const AdminPanel = () => {
  const { isLoading, adminProfile, studentsRecords, adminLogout } = useAdminPanel();
  const { isAuthenticated } = useAdminAuth(); // Get isAuthenticated from context
// for debugging
  // useEffect(() => {
  //   console.log("👨‍💼 AdminPanel render:", {
  //     isLoading,
  //     studentsCount: studentsRecords?.length,
  //     admin: adminProfile?.name,
  //     isAuthenticated // Now this should be correct
  //   });
  // }, [isLoading, studentsRecords, adminProfile, isAuthenticated]);

  if (isLoading) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" minHeight="100vh">
        <CircularProgress />
        <Typography sx={{ ml: 2 }}>Loading...</Typography>
      </Box>
    );
  }

  return (
    <div>
      <AdminPanelHeader />
      <AdminProfileData 
        adminProfile={adminProfile} 
        studentsRecords={studentsRecords} 
        adminLogout={adminLogout} 
      />
    </div>
  );
};

export default AdminPanel;